<template>
  <span
    style="display: inline-block;"
    class=""
  >

    <button
      class="btn btn-sm btn-outline-primary btn-req"
      @click="requestPayment(requestPermission)"
    >
      <img
        :src="paymentHistoryImg"
        alt="i"
        height="14"
        style="filter: invert(1)"
      >
      {{ $t('paymentHistory.requestPayment') }}
    </button>

    <Modal
      v-model:show="active"
      :class="{ 'loading': loadingState }"
      class="request-payment"
      @close="close()"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('paymentHistory.requestPayment') }}
        </h5>
      </template>
      <section class="request__body">
        <div class="tip !tw-flex mb-4">
          {{ $t('paymentHistory.specifySum') }}
          <span class="text-danger">*</span>
        </div>
        <div
          :class="{'is-disabled':loading}"
          class="money form-group m-0"
        >
          <ElInput
            v-model="form.amount"
            placeholder="123.45"
            autocomplete="off"
            :disabled="loading"
            type="text"
            class="request-payment-input"
            @click="errors_.amount = ''"
          >
            <template v-slot:prepend>{{ currencyLabel }}</template>
          </ElInput>
        </div>
        <div class="text-danger !tw-text-right">{{ errors_.amount }}</div>

        <div
          v-if="success && requestPermission"
          class="success__block"
        >
          <div>
            <img
              :src="okImg"
              alt
            >
          </div>
          <span>{{ $t('paymentHistory.withdrawalReview') }}</span>
        </div>

        <div
          v-if="!requestPermission && !success"
          class="success__block"
        >
          <div>
            <i
              v-if="errors_.amount"
              class="far fa-times-circle"
            />
            <img
              v-if="!errors_.amount"
              :src="okImg"
              alt
            >
          </div>
          <span>{{ errors_.amount || $t('paymentHistory.withdrawalRequest') }}</span>
        </div>
      </section>

      <div class="loading__block">
        <i class="fa fa-spinner login__spinner" />
      </div>

      <template v-slot:footer>
        <div class="!tw-text-center !tw-w-full">
          <!-- vue3-migration -- slot="reference" слот не в корне -->
          <button
            v-if="!success && requestPermission"
            :disabled="loading"
            class="btn btn-primary btn-sm d-done !tw-w-full btn-send"
            @click="sendRequest"
          >{{ $t('paymentHistory.sendRequest') }}</button>
          <button
            v-if="success || !requestPermission"
            class="btn btn-primary btn-block big login btn-md"
            @click="close()"
          >{{ $t('paymentHistory.close') }}</button>
        </div>
      </template>
    </Modal>
  </span>
</template>

<script>
import { Modal } from '@/components';
import formatCurrency from '@/mixins/format-currency';

import paymentHistoryImg from '@/assets/theme/sidebar/payment-history.svg';
import okImg from '@/assets/theme/icon/ok.svg';

export default {
  components: {
    Modal,
  },
  props: ['changeSuccess'],
  emits: ['update:changeSuccess', 'refresh'],
  mixins: [formatCurrency],
  data() {
    return {
      active: false,
      loading: false,
      loadingState: false,
      success: false,
      form: {},
      errors_: {},
      poperVis: false,
      requestPermission: false,
      amount: '',
    };
  },
  computed: {
    paymentHistoryImg: () => paymentHistoryImg,
    okImg: () => okImg,
    currencyLabel() {
      return this.getCurrencyLabel(this.$store.state.payments.currencyCode);
    },
  },
  watch: {
    active() {
      this.errors_ = {};
      this.form = {};
    },
    'form.amount': function (value) {
      if (!value || this.amount === value || value.trim() === '' || /^[0-9]+\.[0-9]{2}$/g.test(value)) {
        return;
      }

      value = value.replace(/((?![0-9,.]).)*/g, '').replace(/,/g, '.');

      if (value.includes('.')) {
        const strArray = value.split('.');
        value = `${(+strArray.slice(0, strArray.length - 1).join('')) || '0'}.${strArray.slice(strArray.length - 1)[0].slice(0, 2)}`;
      } else {
        value = `${+value}`;
      }

      this.amount = value;
      this.form = { ...this.form, amount: value };
    },
  },

  mounted() {
    this.$api.getPaymentsHistoryOrder({ status: 'waiting_approve' }).then((res) => {
      this.requestPermission = res.payload.able_to_set_payment_amount;
    });
  },

  methods: {
    requestPayment(v) {
      this.active = true;
      if (!v) {
        this.loadingState = true;
        this.$api
          .postPaymentsHistoryOrderPayment({})
          .then((res) => {
            this.loadingState = false;
          })
          .catch((err) => {
            this.errors_ = {
              amount: err.response.data.errors?.amount[0].message || err.response.data.message,
            };
            this.loadingState = false;
          });
      }
    },

    close() {
      this.$emit('update:changeSuccess', (this.success = false));
      this.active = false;
      this.success = false;
      this.loadingState = false;
    },

    sendRequest() {
      this.errors_ = {};
      this.loading = true;
      this.$api
        .postPaymentsHistoryOrderPayment({ amount: this.form.amount })
        .then(() => {
          this.loading = false;
          this.success = true;

          this.$emit('refresh');
          this.$parent.getWaintingApproval(this.success);
        })
        .catch((err) => {
          this.loading = false;
          this.errors_ = {
            amount: err.response.data.errors?.amount[0].message || err.response.data.message,
          };
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .money.form-group .request-payment-input {
    border: 1px solid #d9d9d9;
    border-radius: 8px;

    // /deep/ {
    // vue3-migration -- удаляем /deep/
      :deep(&.el-input__inner) {
        border: 0!important;
        padding-left: 0;
      }
      :deep(.el-input-group__prepend) {
        background: transparent;
        border: 0;
        padding-right: 4px;
        padding-left: 12px;
        color: inherit;
      }
    // }
  }
</style>

<style lang="scss">
.request-payment {
  .modal-dialog {
    width: 500px;
  }
  .request__body {
    padding-top: 24px;
    padding-bottom: 24px;
    .tip {
      font-weight: normal;
      font-size: 14px;
    }
    .input-group-append {
      padding-top: 4px;
      left: 12px;
      font-size: 18px;
      position: absolute;
    }
    .form-control {
      padding-left: 28px !important;
      margin-left: 0 !important;
    }
    .success__block {
      display: flex !important;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      background: #fff;
      > div {
        padding-bottom: 24px;
      }
    }

    .text-danger {
      width: auto!important;
    }
  }
  .btn-send {
    width: auto !important;
    float: right;
  }
  .btn-done {
    width: auto;
    margin: 10px auto;
  }
}

.request-payment.loading{
  .modal-header, .request__body, .modal-footer{
    opacity: 0;
    *{
      cursor: unset !important;
      pointer-events: none !important;
    }
  }
  .login__spinner:before{
    font-size: 45px;
    top: 35%;
    left: 45%;
  }
}

</style>
